import { IScreen } from "@webapp/navigation/models/shared.models";

export const SCREENS: IScreen[] = [
  { icon: "home", state: "gtmhub.home", key: "home" },
  { icon: "target", state: "gtmhub.sessions", key: "sessions" },
  { icon: "chart", state: "gtmhub.kpis", key: "kpis" },
  { icon: "task", state: "gtmhub.tasks", key: "tasks" },
  { icon: "whiteboards", state: "gtmhub.whiteboards", key: "whiteboards" },
  { icon: "pie", state: "gtmhub.insightboard", key: "reports" },
  { icon: "consulting", state: "gtmhub.insightboards", key: "insightboards" },
  { icon: "users-group", state: "gtmhub.employees", key: "people" },
];

// Marketplace and Help do not have states, one is a link, the other one dropdown
// We will need to change that
export const SUPPORT_SCREENS = [
  // { icon: "add-from-marketplace", href: "gtmhub.home", key: "marketplace" },
  { icon: "manage", state: "gtmhub.configuration.methodology", key: "settings" },
  // { icon: "help", state: "gtmhub.home", key: "help" },
] as IScreen[];

export const NAV_WIDTH = {
  expanded: 250,
  collapsed: 44,
};

export const TOP_NAV_BAR_PROPS = {
  height: 45,
  borderColor: "#d8dfea",
};
